import { ActionIcon, Box, Modal, Tooltip } from "@mantine/core";
import { useState } from "react";
import { FaExpand } from "react-icons/fa";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import { useAppSelector } from "../../app/hooks";
import StandardRoomViewerFilters from "./StandardRoomViewerFilters";
import {
  selectActiveStandardRoomCeilingGridPixPaths,
  selectActiveStandardRoomDimensionLines,
  selectActiveStandardRoomExtentKey,
  selectActiveStandardRoomPixPolygons,
} from "./standardroomSelectors";

const StandardRoomViewerContent: React.FC<{ openOnClick?: () => void }> = ({ openOnClick }) => {
  const pixPolygons = useAppSelector(selectActiveStandardRoomPixPolygons);
  const pixPaths = useAppSelector(selectActiveStandardRoomCeilingGridPixPaths);
  const dimensionLines = useAppSelector(selectActiveStandardRoomDimensionLines);
  const extentKey = useAppSelector(selectActiveStandardRoomExtentKey);

  return (
    <Box h="100%" style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
      <StandardRoomViewerFilters />
      <Box
        h="100%"
        bg="#f8fafc"
        style={{
          overflow: "hidden",
          position: "relative",
          minHeight: 0,
        }}
      >
        {openOnClick && (
          <Tooltip label="Ã…pne i fullskjerm" withArrow>
            <ActionIcon
              variant="white"
              color="gray"
              radius="xl"
              size="sm"
              aria-label="Ã…pne standardromviewer i fullskjerm"
              onClick={openOnClick}
              style={{
                position: "absolute",
                top: 8,
                right: 10,
                zIndex: 2,
                boxShadow: "0 1px 3px rgba(15, 23, 42, 0.18)",
              }}
            >
              <FaExpand size={11} />
            </ActionIcon>
          </Tooltip>
        )}
        <DeckBimViewer
          flip2dCoordinate={true}
          angle={180}
          polygons={pixPolygons}
          paths={pixPaths}
          dimensionLines={dimensionLines}
          zoomExtentKey={extentKey ?? "no-extent"}
        />
      </Box>
    </Box>
  );
};

const StandardRoomViewer = () => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <StandardRoomViewerContent openOnClick={() => setOpened(true)} />

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        fullScreen
        padding={0}
        withCloseButton
        title="Standardrom"
      >
        <Box h="100vh" style={{ minHeight: 0 }}>
          <StandardRoomViewerContent />
        </Box>
      </Modal>
    </>
  );
};

export default StandardRoomViewer;
